import { createSignal } from "solid-js";
import { Buis } from "~/components/Buis";
import { Group } from "~/components/ui/group";
import { Spacer } from "~/components/ui/spacer";
import { Text } from "~/components/ui/text";
import { useDocumentContext } from "../../../providers/context";
import { DocumentBookmarkButton } from "../Buttons/bookmark";
import { DocumentNextArticleButton, DocumentPreviousArticleButton } from "../Buttons/direction";
import { DocumentDownloadButton } from "../Buttons/download";
import { DocumentSpeechButton } from "../Buttons/speech";
import { ContentFrame } from "../ContentFrame";
import { DocumentDesktopSidebar } from "../Sidebar/desktop";

export interface DocumentWidgetProps {
	id: string;
}

export function Root() {
	const { selected, documentTitle } = useDocumentContext();

	const [targetHeight, setTargetHeight] = createSignal(0);

	return (
		<>
			<Text class="text-xl font-semibold mb-8">{documentTitle()}</Text>
			<div class="grid grid-cols-12">
				<DocumentDesktopSidebar height={targetHeight} />
				<div class="col-span-8 pl-8">
					<Group class="mb-4">
						<DocumentPreviousArticleButton />
						<DocumentNextArticleButton />
					</Group>
					<Group class="mb-4">
						<div>
							<Buis
								class="text-gray-600 block mb-1.5"
								value={selected()?.breadcrumb}
							/>
							<Buis
								class="text-2xl block font-medium"
								value={selected()?.title}
							/>
						</div>
						<Spacer />
						<DocumentDownloadButton />
						<DocumentSpeechButton />
						<DocumentBookmarkButton />
					</Group>
					<ContentFrame
						article={selected}
						onHeightChange={setTargetHeight}
					/>
				</div>
			</div>
		</>
	);
}
